export default "__VITE_ASSET__CnCVJroC__"